<script lang="ts">
  import type { Event, EventHoursOccurrence, Place } from "../../types";
  import { find } from "lodash-es";
  import { getNow } from "../../data/clock";
  import { eventPath } from "../../support/links";
  import { pastEventHours, presentEventHours, futureEventHours } from "./view-model";
  import StatusTable from "../status-table.svelte";

  export let time = getNow();
  // Note - we assume all events are for today
  export let entries: Array<EventHoursOccurrence> = [];
  export let places: Place[];
  export let events: Event[];
  export let showEventEndTime = false;

  function mapEntry(entry: EventHoursOccurrence) {
    let place = find(places, { id: entry.placeId });
    let event = find(events, { id: entry.eventId });

    let isEvent = event?.type == "event";

    return {
      title: event.title,
      subtitle: place ? `at ${place.title}` : null,
      time: entry.from,
      timeEnd: showEventEndTime && isEvent ? entry.until : null,
      href: eventPath(event)
    };
  }

  $: inPast = pastEventHours(entries, $time);
  $: inProgress = presentEventHours(entries, $time);
  $: inFuture = futureEventHours(entries, $time);

  let sortFields = ["time", "timeEnd", "title"];
</script>

{#if inPast.length > 0}
  <div class="Past">
    <StatusTable
      title="dailySchedule.pastEvents"
      detail="dailySchedule.time"
      sortField={sortFields}
      showHeader={false}
      entries={inPast.map(mapEntry)}
    />
  </div>
{/if}

<StatusTable
  color="var(--color-status-green)"
  title="dailySchedule.inProgress"
  detail="dailySchedule.time"
  icon="icon-check"
  entries={inProgress.map(mapEntry)}
  sortField={sortFields}
  noMargin={true}
/>

<StatusTable
  showHeader={false}
  title="dailySchedule.laterToday"
  detail="dailySchedule.time"
  sortField={sortFields}
  entries={inFuture.map(mapEntry)}
  noMargin={true}
/>

<style>
  .Past {
    opacity: 0.62;
  }
</style>
